import React from 'react'
import { CustomerMain } from './components'

const CustomerReport = () => <CustomerMain />

export default CustomerReport